import React, { useContext } from 'react';
import { LeReacteurContext } from '../Layout';
import Icons from '../Icons';
import { H2, TextContainer } from '../Typography';
import { IconContainer, QuestionContainer, Answer, QAContainer } from './elements';

const QAItem = ({ question, answer, isOpen, onQuestionClick, containerRef }) => {
  const { dtlToggleInteraction } = useContext(LeReacteurContext);

  return (
    <QAContainer ref={containerRef}>
      <QuestionContainer
        onClick={(e) => {
          dtlToggleInteraction('faq', 'content', question);
          onQuestionClick(e);
        }}
      >
        <TextContainer css={{ fontWeight: 'bold' }}>
          <H2>{question}</H2>
        </TextContainer>
        <IconContainer>
          {isOpen ? <Icons name="minus" width="25" /> : <Icons name="add" width="30" />}
        </IconContainer>
      </QuestionContainer>
      {isOpen && <Answer dangerouslySetInnerHTML={{ __html: answer }} />}
    </QAContainer>
  );
};

export default QAItem;
